import angular from 'angular';
import { FavoriteDetailPageComponent } from './favorites-detail.view/favoritesDetail';
import { FavoritesDetailSidebarComponent } from './favorites-detail.view/favoritesDetailSidebar';
import { FavoritesFilters } from './favorites-filters.service/favoritesFilters';
import { FavoritesIndex } from './favorites-index.view/favoritesIndex';
import { FavoritesIndexSidebar } from './favorites-index.view/favoritesIndexSidebar';
import { FavoritesRepository } from './favorites-repository.service/favoritesRepository';
import { LocalFavorites } from './local-favorites.service/localFavorites';
import { RemoveFavoriteComponent } from './remove-favorite.view/remove-favorite';
import { EmailFavoriteComponent } from './email-favorite.view/emailFavorite';
import { SaveFavoriteListButtonComponent } from './save-favorite.view/save-favorite-button';
import {
    SaveFavoritePopoverComponent,
    SaveFavoritePopoverController,
} from './save-favorite.view/save-favorite-popover';
import { SaveFavoritePopoverAddComponent } from './save-favorite.view/save-favorite-popover-add';
import { SaveFavoritePopoverSuccessComponent } from './save-favorite.view/save-favorite-popover-success';

export default angular
    .module('tn.favorites', [
        'tn.django',
        'tn.common',
        'tn.user',
        'tn.billing',
        'tn.cart',
        'tn.pricing',
        'tn.popover',
        'tn.fonts',
        'tn.utils',
        'tn.ui',
        'ui.router',
        'angular.filter',
    ])
    // components
    .component('saveFavoritePopoverAdd', SaveFavoritePopoverAddComponent)
    .component(
        'saveFavoritePopoverSuccess',
        SaveFavoritePopoverSuccessComponent
    )
    .component('saveFavoritePopover', SaveFavoritePopoverComponent)
    .component('saveFavoriteButton', SaveFavoriteListButtonComponent)
    .component('favoriteDetailPage', FavoriteDetailPageComponent)
    .component('favoritesDetailSidebar', FavoritesDetailSidebarComponent)
    .component('emailFavoritePopover', EmailFavoriteComponent)
    .component('removeFavoritePopover', RemoveFavoriteComponent)
    .controller('tnFavoritesIndex', FavoritesIndex)
    .controller('tnFavoritesIndexSidebar', FavoritesIndexSidebar)
    .controller('tnSaveFavorite', SaveFavoritePopoverController)

    // providers
    .service('tn.favorites.filters.service', FavoritesFilters)
    .service('favoritesRepository', FavoritesRepository)
    .service('localFavorites', LocalFavorites).name;
